module.exports = __webpack_public_path__ + "img/map_yandex_en.ab6211fc.jpg";